import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import datefns from "date-fns";
import SubcategoryFragment from "./SubcategoryFragment";
import TrowFragment from "./TrowFragment";
import Popup from "./Popup";
import PopupContent from "./PopupContent";
import CloseButton from "./CloseButton";


export default class DateMenu extends React.Component {
  state = {};
  componentDidMount() {
    this.parseDates(this.props.dates);
    this.getStyle();
    window.addEventListener('resize', () => this.getStyle());
    document.addEventListener('scroll', () => this.getStyle());
  }

  getStyle = () => {
    const parent = document.getElementById('date-menu-button');
    const rect = parent.getBoundingClientRect();
    this.setState({ parent, rect })
  }

  parseDates(arrOfDates) {
    const sortedDates = arrOfDates
      .map( d => (datefns.parse(d)
    )).sort((date1, date2) => (date2 - date1));
      //.map( d => (datefns.format(d, "YYYYMMDD")));

    this.setState({ sortedDates })
  }

  render() {
    const { open } = this.props;
    if(!this.state) {
      return (
        <button id={"date-menu-button"} className={cx("closed-menu", "date-menu", {open: open})}
                onClick={this.props.handleMenuToggle}>
          <h3>{this.props.title}</h3>
        </button>
      )
    } else {
        return (
          <button id={"date-menu-button"} className={cx("closed-menu", "date-menu", { open: open })} onClick={this.props.handleMenuToggle}>
            <h3>{this.props.title}</h3>
            {open && (
              <Popup>
              <div className="date-menu opened">
              <PopupContent top={this.state.rect.top} left={this.state.rect.right+5}>
                <CloseButton handleCloseButton={this.props.handleCloseButton} />
                {this.state.sortedDates.map( (d, i, arr) => {
                  let date = datefns.format(d, "YYYYMMDD");
                  if(i === 0 || datefns.getYear(d) !== datefns.getYear(arr[i-1])) {
                     return (
                       <div>
                          <div className="category">{datefns.getYear(d)}</div>
                          <SubcategoryFragment month={datefns.getMonth(d)}/>
                          <TrowFragment onEvent={this.props.onEvent} date={date} />
                       </div>)
                   } else {
                        if(datefns.getMonth(d) !== datefns.getMonth(arr[i-1])) {
                          return (
                             <div>
                                <SubcategoryFragment month={datefns.getMonth(d)}/>
                                <TrowFragment onEvent={this.props.onEvent} date={date} />
                              </div>
                        )}

                     return (<TrowFragment onEvent={this.props.onEvent} date={date} />);
                  }
                })}
                  </PopupContent>
                </div>
              </Popup>

            )}
          </button>
        );
      }
    }
}

DateMenu.propTypes = {
  title: PropTypes.string,
  menuItems: PropTypes.array,
  onClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/DateMenu.js